import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadManagerLists } from '../actions/managerListsActions';
import { getAllMetadata, getCancellationPolicies, getDsoNames } from '../actions/userActions';
import {
  getAllProfessions,
  getAllSoftwares,
  getAllSpecializations,
} from '../actions/jobsAction';
import { fetchPPRecruiter } from '../actions/ppJobsAction';

/**
 * Loads the shared reference data the admin pages read straight out of redux.
 *
 * This used to live in `Dashboard`'s `componentDidMount`. Dashboard was mounted
 * at `path="/"` with no `exact` and outside the `<Switch>`, so it rendered on
 * every page and doubled as the app's bootstrap. Replacing it with `AppShell`
 * removed the chrome and these fetches with it, leaving consumers reading a
 * permanently `null` `allMetadata` — app versions, job notification config,
 * adjustment reasons, the med-mal survey and parking types all came from here.
 *
 * The shell is the always-mounted component now, so it inherits the job.
 * Deliberately not page data: `fetchUsersForMap` served one page and moved to
 * that page instead of firing on every route.
 */
export const useAppBootstrap = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadManagerLists());
    dispatch(getAllProfessions());
    dispatch(getAllSpecializations());
    dispatch(getAllSoftwares());
    dispatch(getAllMetadata());
    dispatch(fetchPPRecruiter());
    dispatch(getDsoNames());
    dispatch(getCancellationPolicies());
  }, [dispatch]);
};

export default useAppBootstrap;
